import { MessageCircle } from "lucide-react";

const SHARE_TEXT = "Conheça o Instituto GA+. Cuidando de vidas com fé, amor e saúde em Jaboatão dos Guararapes. https://institutogaa.com.br";

export default function WhatsAppShareButton({ className = "", label = "Compartilhar no WhatsApp" }) {
  const href = `https://wa.me/?text=${encodeURIComponent(SHARE_TEXT)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-share-btn"
      className={`inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white font-bold py-2.5 px-5 text-sm hover:bg-[#1ea855] transition-colors ${className}`}
    >
      <MessageCircle className="w-4 h-4" />
      {label}
    </a>
  );
}
